// Libs
import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";
import { StoresInstance } from "Globals/Stores";
import { IsEmail, IsNotEmpty, Matches, IsString, MinLength, MaxLength } from "class-validator";
import { RegisterApplicantDTO } from "Globals/Models/DTO/RegisterApplicantDTO";
import { registerDecorator, ValidationArguments, ValidationOptions, ValidatorConstraint, ValidatorConstraintInterface } from "class-validator";

export function Match(property: string, validationOptions?: ValidationOptions) {
    return (object: any, propertyName: string) => {
        registerDecorator({
            target: object.constructor,
            propertyName,
            options: validationOptions,
            constraints: [property],
            validator: MatchConstraint,
        });
    };
}

@ValidatorConstraint({ name: "Match" })
export class MatchConstraint implements ValidatorConstraintInterface {
    validate(value: any, args: ValidationArguments) {
        const [relatedPropertyName] = args.constraints;
        const relatedValue = (args.object as any)[relatedPropertyName];
        return value === relatedValue;
    }
}

export class RegisterApplicantModel extends ModelBase<RegisterApplicantModel, RegisterApplicantDTO> {
    @MobX.observable
    public token: string = "";

    @IsString()
    @MinLength(7)
    @IsNotEmpty({ message: "Password is required" })
    @Matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{7,}$/, { message: "Password too weak" })
    @MobX.observable
    public password: string = "";

    @IsNotEmpty({ message: "Confirm password is required" })
    @Match("password", { message: "Passwords do not match" })
    @MobX.observable
    public confirmPassword: string = "";

    @MobX.action
    public fromDto = (model: RegisterApplicantDTO): void => {
        if (model !== null && model !== undefined) {
            this.token = model.token;
            this.password = model.password;
        }
    };

    @MobX.action
    public toDto = (): RegisterApplicantDTO => {
        let model: RegisterApplicantDTO = {
            token: this.token,
            password: this.password,
        };
        return model;
    };
}
